<script setup lang="ts">
import MenuHint from '@/application/menu/components/MenuHint.vue';
import { useMenuItems } from '@/application/menu/composables/menuItems';
import { useUserStore } from '@/user/store/userStore';

const { items } = useMenuItems();
const userStore = useUserStore()

</script>

<template>
  <nav
    v-if="userStore.isAuthenticated"
    class="hidden md:flex flex-row items-center justify-center gap-6 lg:gap-10"
  >
    <RouterLink
      v-for="{ title, to, unreadHints } in items"
      v-slot="{ href, navigate, isActive }"
      :key="title"
      :to="to()"
      custom
    >
      <a
        :href="href"
        :class="{'active-nav-button': isActive}"
        class="nav-button relative"
        @click="navigate"
        @keydown.enter="navigate"
      >
        {{ title }}
        <MenuHint :number="unreadHints" />
      </a>
    </RouterLink>
  </nav>

  <RouterLink
    v-else
    class="hidden md:block text-dark font-bold justify-self-center"
    to="/"
  >
    meine-finanzen.digital
  </RouterLink>
</template>

<style scoped>
@reference '../../../../css/tailwind.css';

.nav-button {
  @apply lg:text-lg text-gray-800 font-medium;
  @apply hover:text-blue-700 hover:decoration-blue-700;
  @apply hover:underline hover:decoration-[3px] hover:underline-offset-[16px];
}

.active-nav-button {
  @apply text-blue-700 underline decoration-blue-700 decoration-[3px] underline-offset-[16px];
}
</style>
